<div class="container section__finalMsg h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-300">
      <article>
        <div class="mainInfo mainInfo--maxWidthExtend">
          <i class="mainIcon mainIcon--kredicash">
            <img src="assets/images/logos/kredicash-logo.png" alt="Kredicash">
          </i>
          <ng-container *ngIf="SalesWorkflowSteps['final-message-bank-transfer'] != message">
            <h1>¡Tu Kredicash ha sido enviado a tu cuenta!</h1>
          </ng-container>

          <ng-container *ngIf="SalesWorkflowSteps['final-message-bank-transfer'] == message">
            <h1>{{ 'Recibirás el desembolso del crédito en las próximas 24 horas.' | termReplace }}</h1>
          </ng-container>

          <p>Gracias por escogernos como tu aliado financiero.</p>
        </div>

        <!-- CLIENTE SIN LUKI -->
        <ng-container *ngIf="false">
          <div class="msgBlock pt-30">
            <div class="msgBlock__wrapper">
              <div class="msgBlock__content">
                <div class="top">
                  <div class="image">
                    <img src="assets/images/logos/luki-logo.png" alt="LUKI">
                  </div>
                  <div class="description">
                    <p>En unos minutos podrás ver tu dinero en tu cuenta.</p>
                  </div>
                </div>

                <div class="bottom">
                  <div class="bottom__image">
                    <div class="image">
                      <img src="assets/images/luki-phone.png" alt="Three phones displaying the Luki app on their screens">
                    </div>
                  </div>
                  <div class="bottom__text">
                    <div class="text">
                      <p>Descarga <strong>Luki</strong> {{ 'para consultar el estado de tu crédito y realiza tus pagos de manera digital.' | termReplace }}</p>
                      <button pButton pRipple label="Descargar Luki" icon="pi pi-download" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-border" (click)="openGooglePlay()"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- CLIENTE CON LUKI -->
        <ng-container *ngIf="SalesWorkflowSteps['final-message-luki'] == message">
          <div class="msgBlock pt-30">
            <div class="msgBlock__wrapper">
              <div class="msgBlock__content">
                <div class="top top--luki">
                  <div class="image">
                    <img src="assets/images/logos/luki-logo.png" alt="Luki logo">
                  </div>
                  <div class="description bigMaxWidth">
                    <p>{{ 'En unos minutos podrás ver tu dinero en tu cuenta. Recuerda consultar el estado de tu crédito a través de Luki y realiza tus pagos de manera digital.' | termReplace }}</p>
                  </div>
                </div>
                <div class="background">
                  <svg width="353" height="69" viewBox="0 0 353 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_3454_10069" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="353" height="69">
                      <rect width="353" height="69" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_3454_10069)">
                      <path d="M148.62 52.286L-245.069 -71.2373C-275.588 -74.4667 -289.739 -66.6624 -293 -62.3566L-287.131 40.9832L-27.9103 126.158C-18.7805 128.984 8.0871 136.734 42.5194 145.13C159.12 173.872 259.352 157.106 294.893 145.13C333.694 131.675 428.318 98.7889 496.4 74.8916C564.482 53.5778 579.546 43.4053 578.568 40.9832C578.894 15.4174 579.35 -39.2666 578.568 -53.4758C563.699 -68.008 531.941 -62.7602 517.92 -58.3199C422.383 -24.9497 234.438 42.0883 204.377 52.286C180.249 60.4716 172.784 60.1322 148.62 52.286Z" fill="#0E1A7E"/>
                      <mask id="mask1_3454_10069" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-293" y="-72" width="872" height="233">
                        <path d="M148.62 51.9809L-245.069 -71.2392C-275.588 -74.4606 -289.739 -66.6755 -293 -62.3802L-287.131 40.7059L-27.9103 125.671C-18.7805 128.49 8.0871 136.222 42.5194 144.597C159.12 173.268 259.352 156.544 294.893 144.597C333.694 131.175 428.318 98.3697 496.4 74.531C564.482 53.2695 579.546 43.122 578.568 40.7059C578.894 15.2028 579.35 -39.3469 578.568 -53.5213C563.699 -68.0178 531.941 -62.7829 517.92 -58.3534C422.383 -25.0652 234.438 41.8082 204.377 51.9809C180.249 60.1464 172.784 59.8079 148.62 51.9809Z" fill="#131D7C"/>
                      </mask>
                      <g mask="url(#mask1_3454_10069)">
                        <g filter="url(#filter0_f_3454_10069)">
                          <ellipse cx="165.329" cy="77.5" rx="177.456" ry="72.5" fill="#434FB8" fill-opacity="0.27"/>
                        </g>
                      </g>
                    </g>
                    <defs>
                      <filter id="filter0_f_3454_10069" x="-90.127" y="-73" width="510.911" height="301" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feGaussianBlur stdDeviation="39" result="effect1_foregroundBlur_3454_10069"/>
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- TRANSFERENCIA A OTROS BANCOS -->
        <ng-container *ngIf="SalesWorkflowSteps['final-message-bank-transfer'] == message">
          <div class="msgBlock pt-30">
            <div class="msgBlock__wrapper">
              <div class="msgBlock__content">
                <div class="bottom inverted lightBlue">
                  <div class="bottom__image">
                    <div class="image">
                      <img src="assets/images/krediya-app.png" alt="KrdYa App">
                    </div>
                  </div>
                  <div class="bottom__text">
                    <div class="text">
                      <p>Descarga <strong>KrdYa</strong> {{ 'para consultar el estado de tu crédito y realiza tus pagos de manera digital.' | termReplace }}</p>
                      <button pButton pRipple label="Descargar" icon="pi pi-download" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-border small" (click)="openGooglePlay()"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </article>
    </div>
  </div>
</div>
